export const getApiServerUrl = (): string => {
  try {
    return new URL(window.appConfig.API_SERVER_URL as string)
      .toString()
      .replace(/\/$/, '');
  } catch {
    return window.origin;
  }
};
